import * as yup from 'yup';
import { EmploymentStatus } from '../../AccountOpening.meta';

export const employmentStatusOpts = [
  {
    label: 'Employed',
    value: EmploymentStatus.Employed,
  },
  {
    label: 'Retired',
    value: EmploymentStatus.Retired,
  },
  {
    label: 'Student',
    value: EmploymentStatus.Student,
  },
  {
    label: 'Unemployed',
    value: EmploymentStatus.Unemployed,
  },
];

export const employmentStatusToForm = (
  employmentStatus: EmploymentStatus | null,
): EmploymentStatus => {
  const foundEmploymentStatus = employmentStatusOpts.find(
    ({ value }) => value === employmentStatus,
  );

  return foundEmploymentStatus?.value || EmploymentStatus.Employed;
};

export const jobTitleValidation = yup
  .string()
  .nullable()
  .when('employmentStatus', {
    is: status => status === EmploymentStatus.Employed,
    then: yup
      .string()
      .nullable()
      .required('Occupation is required'),
  });

export const companyNameValidation = yup
  .string()
  .nullable()
  .when('employmentStatus', {
    is: EmploymentStatus.Employed,
    then: yup
      .string()
      .nullable()
      .required('Company Name is required'),
  });
